import { useTranslation } from "react-i18next";
import { Avatar, Badge } from "@akuna/ui";
import { isActiveMember, type TeamMemberDetail } from "@/lib/team/types";
import { getInitials } from "@/lib/utils/string-utils";

export function MemberHeader({ member }: { member: TeamMemberDetail }) {
  const { t } = useTranslation("team");
  return (
    <div className="flex items-center gap-4">
      <Avatar
        className="h-14 w-14 text-lg"
        name={member.full_name}
        fallback={getInitials(member.full_name)}
        src={member.avatar_url ?? undefined}
      />
      <div className="flex min-w-0 flex-col gap-1.5">
        <h1 className="truncate text-2xl font-bold text-foreground">{member.full_name}</h1>
        <div className="flex flex-wrap gap-1.5">
          {member.job_title && <Badge>{member.job_title}</Badge>}
          {member.employment_type && <Badge>{t(`employment.${member.employment_type}`)}</Badge>}
          {member.is_owner && <Badge variant="warning">{t("member.ownerBadge")}</Badge>}
          {member.is_self && <Badge variant="info">{t("member.you")}</Badge>}
          {isActiveMember(member) ? <Badge variant="success">{t("status.active")}</Badge> : <Badge>{t("status.inactive")}</Badge>}
        </div>
      </div>
    </div>
  );
}
